const module = {
  routes: [
    {
      path: '/terminals',
      component: () => import('@/modules/terminals/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
